import { ApolloCache, Reference } from '@apollo/client';
import { UpdateUserMutationVariables } from 'generated/graphql';
import { cacheDashboardListItemMaybe } from './cacheDashboardListItemMaybe';

export const updateCachedUser = (
  cache: ApolloCache<unknown>,
  _: unknown,
  options: { variables?: UpdateUserMutationVariables },
) => {
  const { variables } = options;

  if (!variables) {
    return;
  }

  const addPinnedDashboardIDs =
    // gqlgen generates string array types as string[] | string
    typeof variables.addPinnedDashboardIDs === 'string'
      ? []
      : variables.addPinnedDashboardIDs;

  const addedReferences = addPinnedDashboardIDs
    ?.filter((id) => cacheDashboardListItemMaybe(cache, id))
    .map(
      (id): Reference => ({
        __ref:
          cache.identify({
            __typename: 'DashboardListItem',
            id,
          }) ?? '',
      }),
    );

  cache.modify({
    id: cache.identify({
      __typename: 'User',
      id: variables.id,
    }),
    fields: {
      pinnedDashboards: (existing: Reference[]) => {
        if (addedReferences) {
          return [...existing, ...addedReferences];
        }

        if (
          !variables?.removePinnedDashboardIDs ||
          // gqlgen generates string array types as string[] | string
          typeof variables?.removePinnedDashboardIDs === 'string'
        ) {
          return existing;
        }
        const removedReferencesSet = new Set(
          variables?.removePinnedDashboardIDs.map(
            (id) =>
              cache.identify({
                __typename: 'DashboardListItem',
                id,
              }) ?? '',
          ),
        );
        return existing.filter(({ __ref }) => !removedReferencesSet.has(__ref));
      },
    },
  });
};
